module.exports = __webpack_public_path__ + "img/solution3_chart4.97b2e6da.png";